import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@fontsource/roboto/400.css';
import './App.css';
import Header from './components/Elements/Header';
import Footer from './components/Elements/Footer';
import PasswordRecover from './components/PasswordRecover';
import PasswordReset from './components/PasswordReset';
import PasswordGenerate from './components/PasswordGenerate';
import Login from './components/Login';
import Logout from './components/Logout';
import Dashboard from './components/Dashboard';
import OportunidadDetalle from './components/OportunidadDetalle';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';

import { ThemeProvider } from '@mui/material';
import Theme_lp from './components/Theme/Theme_lp';
import { Box } from '@mui/material';

function App() {

  const config = {
    backend_api: process.env.REACT_APP_API_URL,
  };

  return (
    <ThemeProvider theme={Theme_lp}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes config={config} />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

function AppRoutes({ config }) {
  const { loggedIn } = useAuth();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {loggedIn && <Header />}
      <main sx={{ flex: 1, pt: loggedIn ? 8 : 0 }}>
        <Routes>
          <Route index element={<Login config={config} />} />
          <Route path="/login" element={<Login config={config} />} />
          <Route path="/recover" element={<PasswordRecover config={config} />} />
          <Route path="/reset" element={<PasswordReset config={config} />} />
          <Route path="/generate" element={<PasswordGenerate config={config} />} />
          <Route path="/logout" element={<Logout config={config} />} />
          
          <Route element={<ProtectedRoute config={config} />}>
            <Route path="/dashboard" element={<Dashboard config={config} />} />
            <Route path="/dashboard/summary" element={<Dashboard config={config} />} />
            <Route path="/dashboard/investments-active" element={<Dashboard config={config} />} />
            <Route path="/dashboard/investments-closed" element={<Dashboard config={config} />} />
            <Route path="/dashboard/tax" element={<Dashboard config={config} />} />
            <Route path="/dashboard/opportunities" element={<Dashboard config={config} />} />
            <Route path="/opportunity/:id" element={<OportunidadDetalle config={config} />} />
          </Route>
        </Routes>
      </main>
      {loggedIn && <Footer />}
    </Box>
  );
}

export default App;